import * as React from "react";
import { Route, Routes } from "react-router-dom";
import { DiarySessionList } from "./List/DiarySessionList";
import { DiaryResults } from "./Results/DiaryResults";

export const DiaryRoot = () => {
    return (
        <><Routes>
            <Route index element={<DiarySessionList/>} />
            <Route path="Results/:id" element={<DiaryResults />} />
        </Routes>
        </>
        );
}
